import { State } from "..";

export const getLicense = (state: State) => state.about.checkLicense?.success;
export const getRefreshLicenseReqInfo = (state: State) =>
	state.about.refreshLicense;
